import { useState } from "react";
import { KeyRound, Loader2, Check } from "lucide-react";
import { authApi, formatApiError } from "@/lib/nexus";
import { useAuth } from "@/context/AuthContext";

export default function ChangePasswordModal({ forced = false, onClose }) {
  const { user, setUser } = useAuth();
  const [form, setForm] = useState({ old_password: "", new_password: "", confirm: "" });
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (form.new_password !== form.confirm) { setErr("New passwords do not match."); return; }
    setBusy(true);
    try {
      await authApi.changePassword(form.old_password, form.new_password);
      setDone(true);
      if (user) setUser({ ...user, must_change_password: false });
      setTimeout(() => onClose?.(), 900);
    } catch (e2) {
      setErr(formatApiError(e2));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[60] bg-black/75 flex items-center justify-center p-4" onClick={() => !forced && onClose?.()}>
      <form className="panel brackets p-5 w-full max-w-sm" data-testid="change-password-modal" onClick={(e) => e.stopPropagation()} onSubmit={submit}>
        <span className="b1" /><span className="b2" />
        <div className="flex items-center gap-2 text-nexus-cyan"><KeyRound size={16} /><span className="panel-title">Change Password</span></div>
        {forced && <p className="text-nexus-amber text-[12px] font-mono mt-2">You must set a new password before continuing.</p>}
        <label className="block mt-4"><span className="panel-title">Current password</span>
          <input data-testid="cp-old" type="password" required value={form.old_password} onChange={(e) => setForm({ ...form, old_password: e.target.value })}
            className="mt-1 w-full bg-nexus-bg border border-nexus-border px-3 py-2 text-[13px] font-mono focus:border-nexus-cyan/60 outline-none" /></label>
        <label className="block mt-3"><span className="panel-title">New password</span>
          <input data-testid="cp-new" type="password" required minLength={8} value={form.new_password} onChange={(e) => setForm({ ...form, new_password: e.target.value })}
            className="mt-1 w-full bg-nexus-bg border border-nexus-border px-3 py-2 text-[13px] font-mono focus:border-nexus-cyan/60 outline-none" />
          <span className="text-[10px] font-mono text-nexus-text-3">min 8 characters</span></label>
        <label className="block mt-3"><span className="panel-title">Confirm new password</span>
          <input data-testid="cp-confirm" type="password" required value={form.confirm} onChange={(e) => setForm({ ...form, confirm: e.target.value })}
            className="mt-1 w-full bg-nexus-bg border border-nexus-border px-3 py-2 text-[13px] font-mono focus:border-nexus-cyan/60 outline-none" /></label>
        {err && <div data-testid="cp-error" className="mt-3 text-[11px] font-mono text-nexus-rose border border-nexus-rose/40 bg-nexus-rose/5 px-2 py-1.5">{err}</div>}
        <div className="flex gap-2 mt-5">
          {!forced && <button type="button" onClick={onClose} className="flex-1 border border-nexus-border text-nexus-text-2 py-2 text-[11px] font-mono uppercase tracking-widest hover:text-nexus-text">Cancel</button>}
          <button data-testid="cp-submit" type="submit" disabled={busy || done} className="flex-1 border border-nexus-cyan/60 text-nexus-cyan py-2 text-[11px] font-mono uppercase tracking-widest hover:bg-nexus-cyan/10 disabled:opacity-50 flex items-center justify-center gap-2">
            {busy && <Loader2 size={12} className="animate-spin" />} {done ? <><Check size={13} /> Saved</> : "Update Password"}
          </button>
        </div>
      </form>
    </div>
  );
}
